import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { SmsAdv, SmsAdvList } from '@models/smsadv/smsadv';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SmsAdvCampaignsService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  /**
   * Return the list of Sms Adv Campaign
   * @param status Available values : DRAFT, SCHEDULED, PENDING, SENDING, SENT, ARCHIVED, ERROR
   */
  getSmsAdvCampaignsList(page?, size?, sortColumn?, sortDirection?, status?): Observable<SmsAdvList> {
    let params = new HttpParams();

    if (page) {
      params = params.append('page', page);
    }
    if (size) {
      params = params.append('size', size);
    }
    if (sortColumn) {
      params = params.append('sortColumn', sortColumn);
    }
    if (sortDirection) {
      params = params.append('sortDirection', sortDirection);
    }
    if (status) {
      params = params.append('status', status);
    }

    return this.http
      .get<Response>(this.baseUrl + 'smsadv/campaigns', { params })
      .pipe(
        map(data => {
          return SmsAdvList.deserialize({
            data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => SmsAdv.deserialize(data2)),
            total: (data as any).total
          });
        })
      );
  }

  /**
   * Create a new sms adv campaign from an existing one
   */
  copySmsAdvCampaign(idSmsAdvCampaign): Observable<SmsAdv> {
    return this.http.post<SmsAdv>(this.baseUrl + 'smsadv/campaigns/' + idSmsAdvCampaign + '/copy', {});
  }
}
